import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Responsive } from '../../../common/Responsive'
import { FILTER_BY } from '../../constant'
import style from '../index.module.scss'
import { selectFilter } from '../store/slice'
import { Category } from './Category'
import ListSelect from './ListSelect'
import { SearchCompany } from './SearchCompany'
import SearchPerson from './searchPerson'

export const HeaderConnectMap = () => {
  const filterBy = useSelector(selectFilter('filterBy'))

  const renderComponent = () => {
    return (
      <div style={{ paddingTop: 12 }}>
        <Element className={style.groupAction}>
          <Category />
          {filterBy === FILTER_BY.COMPANY ? (
            <SearchCompany />
          ) : (
            <SearchPerson />
          )}
        </Element>
        <ListSelect />
      </div>
    )
  }

  return (
    <Responsive renderResponsive={renderComponent}>
      {renderComponent()}
    </Responsive>
  )
}
